module.exports = __webpack_public_path__ + "img/bb1.ff0f8465.png";